export const skills: string[] = [
  "TypeScript",
  "JavaScript",
  "Vue",
  "Java",
  "Angular",
  "Svelte",
  "React",
  "NestJS",
  "SQL",
  "Android",
  "iOS",
  "Docker",
  "HTML",
  "CSS",
  "Git",
];
